import {Component, Input, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {CallService} from "../../services/call/call.service";
import {PatientCreateComponent} from "../../../pages/definition/patient/patient-create/patient-create.component";
import {ICall} from "../../services/call/interface/call.interface";
import {ParameterService} from "../../services/parameter/parameter.service";
import {ApiService} from "../../services/api/api.service";
import {AppMessageService} from "../../services/app-message/app-message.service";
import {AppAlertService} from "../../services/app-alert/app-alert.service";
import {Router} from "@angular/router";
import {split} from "lodash";

declare let $: any;

@Component({
  selector: 'app-call-card-view-popup',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './call-card-view-popup.component.html',
  styleUrl: './call-card-view-popup.component.scss',
})

export class CallViewPopupComponent implements OnInit {
  @ViewChild('showPatient') showPatientForm: PatientCreateComponent;
  @Input() call: ICall;

  loading: boolean = false;
  systemLanguage: string;
  calls: ICall[] = [];
  isMinimized = false;
  isMinimizedResult = false;
  isOtherResult = false;
  visible: boolean = false;

  relatedMenuItems = [
    {
      id: "patient",
      label: 'call-receiving-popup.patient',
      svg: '<svg width="45" height="45" viewBox="0 0 53 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.6103 0H3.26952C1.46793 0 6.23803e-05 1.44638 6.23803e-05 3.22159V8.27753C6.23803e-05 8.76308 0.401576 9.15869 0.894317 9.15869C1.38706 9.15869 1.78857 8.76306 1.78857 8.27753V3.22159C1.78857 2.41744 2.45342 1.76233 3.26952 1.76233H18.6076C19.4237 1.76233 20.0886 2.41744 20.0886 3.22159L20.0912 16.7784C20.0912 17.5826 19.4263 18.2377 18.6102 18.2377H3.26946C2.45336 18.2377 1.78851 17.5826 1.78851 16.7784V11.2524C1.78851 10.7668 1.387 10.3712 0.894255 10.3712C0.401514 10.3712 0 10.7668 0 11.2524V16.7784C0 18.5536 1.46787 20 3.26946 20H18.6076C20.4091 20 21.877 18.5536 21.877 16.7784L21.8796 3.22159C21.8796 1.44638 20.4119 0 18.6103 0ZM7.68339 9.32594C7.16195 8.64774 6.84908 7.80505 6.84908 6.89048C6.84908 4.66823 8.68197 2.86217 10.9372 2.86217C13.1925 2.86217 15.0306 4.66823 15.0306 6.89048C15.0306 7.80505 14.7177 8.6503 14.1963 9.32851C15.8649 9.87829 17.0956 11.728 17.0956 13.9169V16.2625C17.0956 16.748 16.6941 17.1436 16.2013 17.1436L5.67823 17.141C5.18546 17.141 4.78397 16.7454 4.78397 16.2599V13.9143C4.78397 11.7255 6.01476 9.87576 7.68339 9.32594ZM8.64026 6.89048C8.64026 8.14159 9.67274 9.15896 10.9398 9.15896C12.2095 9.15896 13.242 8.14159 13.242 6.89048C13.242 5.64193 12.2095 4.62456 10.9398 4.62456C9.67014 4.62456 8.64026 5.64193 8.64026 6.89048ZM6.57269 15.3785H15.307V13.9167C15.307 12.293 14.324 10.9237 13.1639 10.9237H8.71848C7.55564 10.9237 6.57535 12.2956 6.57535 13.9167L6.57269 15.3785ZM26.573 5.38241H52.1057C52.5985 5.38241 53 4.98677 53 4.50125C53 4.01572 52.5985 3.62008 52.1057 3.62008H26.573C26.0802 3.62008 25.6787 4.01572 25.6787 4.50125C25.6787 4.98677 26.0776 5.38241 26.573 5.38241ZM52.1057 9.12042H26.573C26.0802 9.12042 25.6787 9.51605 25.6787 10.0016C25.6787 10.4871 26.0802 10.8827 26.573 10.8827H52.1057C52.5985 10.8827 53 10.4871 53 10.0016C53 9.51605 52.6011 9.12042 52.1057 9.12042ZM26.573 16.3858H39.3407C39.8335 16.3858 40.2349 15.9902 40.2349 15.5047C40.2349 15.0191 39.8334 14.6235 39.3407 14.6235H26.573C26.0802 14.6235 25.6787 15.0191 25.6787 15.5047C25.6787 15.9902 26.0776 16.3858 26.573 16.3858Z" /></svg>'
    },
    {
      id: 'instituation',
      label: 'call-receiving-popup.instituations',
      svg: '<svg width="31" height="26" viewBox="0 0 31 26" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30.4835 24.9597H29.4502V6.23967C29.4502 5.37778 28.7565 4.67967 27.9002 4.67967H24.8002C24.5147 4.67967 24.2835 4.91237 24.2835 5.19967C24.2835 5.48697 24.5147 5.71967 24.8002 5.71967H27.9002C28.1856 5.71967 28.4168 5.95237 28.4168 6.23967V8.31967H25.3168C25.0314 8.31967 24.8002 8.55237 24.8002 8.83967V11.4397C24.8002 11.727 25.0314 11.9597 25.3168 11.9597H28.4168V13.5197H25.3168C25.0314 13.5197 24.8002 13.7524 24.8002 14.0397V16.6397C24.8002 16.927 25.0314 17.1597 25.3168 17.1597H28.4168V18.7197H25.3168C25.0314 18.7197 24.8002 18.9524 24.8002 19.2397V21.8397C24.8002 22.127 25.0314 22.3597 25.3168 22.3597H28.4168V24.9597H22.7333V7.27967C22.7333 6.99237 22.5021 6.75967 22.2167 6.75967C21.9312 6.75967 21.7 6.99237 21.7 7.27967V24.9597H19.1167V18.1998C19.1167 17.9125 18.8855 17.6798 18.6 17.6798H12.4C12.1145 17.6798 11.8833 17.9125 11.8833 18.1998V20.7998C11.8833 21.0871 12.1145 21.3198 12.4 21.3198C12.6855 21.3198 12.9167 21.0871 12.9167 20.7998V18.7198H18.0833V24.9598H12.9167V22.8798C12.9167 22.5925 12.6855 22.3598 12.4 22.3598C12.1145 22.3598 11.8833 22.5925 11.8833 22.8798V24.9598H9.3V1.56C9.3 1.2727 9.53121 1.04 9.81667 1.04H21.1833C21.4688 1.04 21.7 1.2727 21.7 1.56V5.20017C21.7 5.48747 21.9312 5.72017 22.2167 5.72017C22.5021 5.72017 22.7333 5.48747 22.7333 5.20017V1.56C22.7333 0.698115 22.0397 0 21.1833 0H9.81667C8.96031 0 8.26667 0.698115 8.26667 1.56V4.68H3.1C2.24364 4.68 1.55 5.37811 1.55 6.24V24.96H0.516667C0.231209 24.96 0 25.1927 0 25.48C0 25.7673 0.231209 26 0.516667 26H30.4833C30.7688 26 31 25.7673 31 25.48C31 25.1927 30.7688 24.96 30.4833 24.96L30.4835 24.9597ZM25.8337 10.9195V9.3595H28.417V10.9195H25.8337ZM25.8337 16.1195V14.5595H28.417V16.1195H25.8337ZM25.8337 21.3195V19.7595H28.417V21.3195H25.8337ZM2.58383 9.35933H5.16716V10.9193H2.58383V9.35933ZM2.58383 14.5593H5.16716V16.1193H2.58383V14.5593ZM2.58383 19.7593H5.16716V21.3193H2.58383V19.7593ZM2.58383 22.3593H5.68383C5.96929 22.3593 6.2005 22.1266 6.2005 21.8393V19.2393C6.2005 18.952 5.96929 18.7193 5.68383 18.7193H2.58383V17.1593H5.68383C5.96929 17.1593 6.2005 16.9266 6.2005 16.6393V14.0393C6.2005 13.752 5.96929 13.5193 5.68383 13.5193H2.58383V11.9593H5.68383C5.96929 11.9593 6.2005 11.7266 6.2005 11.4393V8.83933C6.2005 8.55204 5.96929 8.31933 5.68383 8.31933H2.58383V6.23933C2.58383 5.95204 2.81504 5.71933 3.1005 5.71933H8.26716V24.9592H2.58366L2.58383 22.3593ZM16.534 4.15917V15.5992C16.534 15.8865 16.7652 16.1192 17.0507 16.1192H19.634C19.9195 16.1192 20.1507 15.8865 20.1507 15.5992V4.15917C20.1507 3.87187 19.9195 3.63917 19.634 3.63917H17.0507C16.7652 3.63917 16.534 3.87187 16.534 4.15917ZM19.1173 15.079H17.5673V4.679H19.1173V15.079ZM10.8507 4.15917V15.5992C10.8507 15.8865 11.0819 16.1192 11.3673 16.1192H13.9507C14.2361 16.1192 14.4673 15.8865 14.4673 15.5992V4.15917C14.4673 3.87187 14.2361 3.63917 13.9507 3.63917H11.3673C11.0819 3.63917 10.8507 3.87187 10.8507 4.15917ZM13.434 15.079H11.884V4.679H13.434V15.079Z" /></svg>'
    },
    {
      id: 'caseOngoingPatientInformation',
      label: 'call-receiving-popup.ongoing-services',
      svg: '<svg width="57" height="25" viewBox="0 0 57 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30.3362 17.6341H27.0361C26.681 17.6341 26.393 17.3467 26.393 16.991V14.1929H23.5955C23.2404 14.1929 22.9524 13.9055 22.9524 13.5498V10.2497C22.9524 9.89465 23.2399 9.60662 23.5955 9.60662H26.393V6.80913C26.393 6.45404 26.6805 6.16602 27.0361 6.16602H30.3362C30.6913 6.16602 30.9793 6.45346 30.9793 6.80913V9.60662H33.7768C34.1319 9.60662 34.4199 9.89407 34.4199 10.2497V13.5498C34.4199 13.9049 34.1325 14.1929 33.7768 14.1929H30.9793V16.991C30.9787 17.3467 30.6913 17.6341 30.3362 17.6341ZM33.1337 12.9073V10.8934H30.3362C29.9811 10.8934 29.6931 10.606 29.6931 10.2503V7.45282H27.6792V10.2503C27.6792 10.6054 27.3918 10.8934 27.0361 10.8934H24.2386V12.9073H27.0361C27.3912 12.9073 27.6792 13.1947 27.6792 13.5504V16.3485H29.6931V13.5504C29.6931 13.1953 29.9805 12.9073 30.3362 12.9073H33.1337Z" /><path d="M0.643116 5.06033H15.9075C15.9728 3.69948 17.0911 2.61034 18.4671 2.61034H40.8348C40.836 2.61034 40.8366 2.60975 40.8377 2.60975H43.4347V1.72293C43.4347 0.773131 44.2084 0 45.1587 0C46.1091 0 46.8817 0.773131 46.8817 1.72293V2.60975H47.6956C48.8961 2.60975 50.0284 3.13567 50.8021 4.05223L53.6999 7.48176C55.8281 9.99997 57 13.2033 57 16.5004V18.7114C57 20.0775 55.8887 21.1888 54.5226 21.1888H54.3844C54.0795 22.8499 52.6271 24.1146 50.8785 24.1146C49.1299 24.1146 47.6787 22.8499 47.3738 21.1888H40.8424C40.8412 21.1888 40.8406 21.1894 40.8395 21.1894H26.4211C26.1156 22.8505 24.6644 24.1146 22.9164 24.1146C21.1684 24.1146 19.716 22.8505 19.4105 21.1894H18.8402C17.375 21.1894 16.1664 20.1107 15.9425 18.7073H10.1236C9.7685 18.7073 9.48047 18.4199 9.48047 18.0642C9.48047 17.7091 9.76792 17.4211 10.1236 17.4211H18.4997C18.8548 17.4211 19.1429 17.7085 19.1429 18.0642C19.1429 18.4193 18.8554 18.7073 18.4997 18.7073H17.2747C17.4788 19.3924 18.0893 19.9032 18.8397 19.9032H19.4093C19.7131 18.2397 21.1661 16.9727 22.9158 16.9727C24.6655 16.9727 26.1174 18.2397 26.4211 19.9032H40.1946V11.6401C40.194 11.6337 40.1911 11.6279 40.1911 11.6214C40.1911 11.615 40.1946 11.6092 40.1946 11.6028V3.89597H18.4671C17.8012 3.89597 17.2707 4.41081 17.2059 5.05975H21.011C21.366 5.05975 21.6541 5.34719 21.6541 5.70286C21.6541 6.05852 21.3666 6.34596 21.011 6.34596H16.5693C16.5582 6.34655 16.5494 6.35238 16.5383 6.35238C16.5273 6.35238 16.5179 6.34655 16.5074 6.34596H0.643116C0.288035 6.34596 8.3897e-06 6.05852 8.3897e-06 5.70286C8.3897e-06 5.34719 0.288035 5.06033 0.643116 5.06033ZM45.5955 1.72293C45.5955 1.48621 45.396 1.28622 45.1587 1.28622C44.9179 1.28622 44.7203 1.48213 44.7203 1.72293V2.60975H45.5955V1.72293ZM55.7132 18.712V16.501C55.7132 13.507 54.6497 10.5988 52.7175 8.31261L49.8197 4.88308C49.2897 4.25572 48.5166 3.89597 47.695 3.89597H41.482V10.9789H49.783C50.138 10.9789 50.4261 11.2664 50.4261 11.622C50.4261 11.9777 50.1386 12.2651 49.783 12.2651H41.482V19.9043H47.3726C47.6764 18.2414 49.1282 16.9745 50.8773 16.9745C52.6265 16.9745 54.0801 18.2414 54.3838 19.9043H54.522C55.1785 19.9037 55.7132 19.3697 55.7132 18.712ZM50.8779 22.8295C52.1385 22.8295 53.1629 21.8051 53.1629 20.5451C53.1629 19.2851 52.1385 18.2601 50.8779 18.2601C49.6185 18.2601 48.5941 19.2851 48.5941 20.5451C48.5941 21.8051 49.6185 22.8295 50.8779 22.8295ZM22.9158 18.2595C21.6552 18.2595 20.6308 19.2845 20.6308 20.5445C20.6308 21.8045 21.6552 22.8289 22.9158 22.8289C24.1752 22.8289 25.1996 21.8045 25.1996 20.5445C25.1996 19.2845 24.1752 18.2595 22.9158 18.2595Z" /><path d="M6.82385 10.5284C6.46877 10.5284 6.18074 10.241 6.18074 9.88529C6.18074 9.52963 6.46819 9.24219 6.82385 9.24219H14.9155C15.2706 9.24219 15.5586 9.52963 15.5586 9.88529C15.5586 10.241 15.2711 10.5284 14.9155 10.5284H6.82385Z" /><path d="M2.2233 14.0762H16.7612C17.1163 14.0762 17.4043 14.3636 17.4043 14.7193C17.4043 15.0749 17.1168 15.3624 16.7612 15.3624H2.2233C1.86822 15.3624 1.5802 15.0749 1.5802 14.7193C1.5802 14.3636 1.86822 14.0762 2.2233 14.0762Z" /></svg>'
    },
    {
      id: 'caseEndedPatientInformation',
      label: 'call-receiving-popup.end-cases',
      svg: '<svg width="36" height="27" viewBox="0 0 36 27" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M35.3572 3.85707H5.14326V0.642844C5.14326 0.287673 4.85559 0 4.50042 0C3.29187 0 2.16207 0.469266 1.32153 1.31782C0.469771 2.16317 0.000504312 3.29297 0.000504312 4.49991V24.4283C-0.0284235 25.8072 1.19136 27.0286 2.57188 26.9997H35.3572C35.7123 26.9997 36 26.712 36 26.3568V4.50012C36 4.14495 35.7123 3.85707 35.3572 3.85707ZM34.7143 25.7138H2.57209C1.88423 25.7282 1.27192 25.1175 1.2864 24.4281C1.2864 23.7193 1.86333 23.1424 2.57209 23.1424H4.50062C5.34757 23.1263 5.34436 21.8712 4.50062 21.8567C3.65688 21.8921 2.00799 21.6864 1.2864 22.2151V4.49974C1.25908 3.00674 2.39851 1.62301 3.85778 1.34818V19.2853C3.85778 19.6405 4.14545 19.9281 4.50062 19.9281C4.85579 19.9281 5.14347 19.6405 5.14347 19.2853V5.14271H34.7143V25.7138Z" /><path d="M27.5731 14.1422C27.9282 14.1422 28.2159 13.8545 28.2159 13.4994V12.8565H28.8588C29.2139 12.8565 29.5016 12.5689 29.5016 12.2137C29.5016 11.8585 29.2139 11.5708 28.8588 11.5708H28.2159V10.928C28.2159 10.5728 27.9282 10.2852 27.5731 10.2852C27.2179 10.2852 26.9302 10.5728 26.9302 10.928V11.5708H26.2874C25.9322 11.5708 25.6445 11.8585 25.6445 12.2137C25.6445 12.5689 25.9322 12.8565 26.2874 12.8565H26.9302V13.4994C26.9302 13.8545 27.2179 14.1422 27.5731 14.1422Z" /><path d="M27.6438 17.3575C30.4787 17.3575 32.7865 15.0497 32.7865 12.2147C32.7447 11.4562 32.6162 9.4007 31.4831 9.79924C31.1601 9.9471 31.0187 10.3296 31.1681 10.6526C32.3301 13.105 30.371 16.136 27.6438 16.0735C25.5175 16.0735 23.7867 14.3426 23.7867 12.2164C23.724 9.48915 26.7534 7.52993 29.2076 8.69203C29.9822 9.03434 30.5061 7.88848 29.7443 7.52367C26.4691 5.96316 22.4174 8.57152 22.5013 12.2163C22.5013 15.0513 24.8091 17.3591 27.644 17.3591L27.6438 17.3575Z" /><path d="M9.64317 10.9283H19.286C19.6412 10.9283 19.9289 10.6406 19.9289 10.2854C19.9289 9.93025 19.6412 9.64258 19.286 9.64258H9.64317C8.80104 9.65544 8.79622 10.9138 9.64317 10.9283Z" /><path d="M9.64317 14.7857H19.286C19.6412 14.7857 19.9289 14.498 19.9289 14.1428C19.9289 13.7877 19.6412 13.5 19.286 13.5H9.64317C8.80104 13.5129 8.79622 14.7712 9.64317 14.7857Z" /><path d="M9.6434 21.8579C10.5177 21.8997 11.4064 21.6715 12.1055 21.1363C12.9267 20.5208 14.0742 20.5208 14.8954 21.1363C15.5158 21.6024 16.284 21.8579 17.0602 21.8579H19.2861C20.1282 21.8451 20.133 20.5867 19.2861 20.5722C18.1482 20.5047 16.5379 20.8294 15.6668 20.1078C14.3924 19.1516 12.6101 19.1516 11.3358 20.1078C10.8569 20.479 10.2398 20.606 9.64513 20.5722C8.80299 20.5851 8.79818 21.8435 9.64513 21.8579H9.6434Z" /></svg>'
    },
  ];


  selectCall: ICall;
  selectRelatedTab: string = 'patient';
  selectedRelated: any;

  queues: { id: number, name: string, description: string }[] = [];
  resultCodes: {
    id: number,
    name: string,
    icon: string,
    key: string,
    other: boolean,
    queues: any,
    sort: number
  }[] = [];

  constructor(
    private readonly  translateService: TranslateService,
    private readonly callService: CallService,
    private readonly parameterService: ParameterService,
    private readonly apiService: ApiService,
    private readonly messageService: AppMessageService,
    private readonly appAlertService: AppAlertService,
    private readonly router: Router
  ) {

  }

  ngOnInit() {
    this.initializeLanguage();
    this.subscribeToCalls();
    this.loadResultCodesData();
  }

  private initializeLanguage(): void {
    this.systemLanguage =
      this.translateService?.currentLang ||
      this.translateService?.getDefaultLang() ||
      'tr';
  }

  private subscribeToCalls(): void {
    this.callService.calls$.subscribe(calls => {
      this.calls = calls;
    });
  }

  private loadResultCodesData(): void {
    this.parameterService
      .getValues('calls', 'result-codes')
      .subscribe(response => {
        this.queues = this.mapQueues(response);
        this.resultCodes = this.mapResultCodes(response);
      });
  }

  private mapQueues(response: any): any[] {
    return response.datas.relationData.queues.map((res: any) => ({
      id: res.valueObject.id.value,
      name: res.valueObject.name.value,
      description: res.valueObject.description.value
    }));
  }

  private mapResultCodes(response: any): any[] {
    return response.datas.values.map((res: any) => {
      const id = res.valueObject.id.value;
      const name = res.valueObject.name.value;
      const key = res.valueObject.key.value;
      const icon = res.valueObject.icon.value;
      const sort = res.valueObject.sort.value;

      const queueIds = res.valueObject.queues.value || [];
      const queues = this.mapQueueDetails(queueIds);
      const hasCurrentQueue = queueIds.includes(this.selectCall?.queueNumber);

      return { id, name, key, icon, sort, queues, other: hasCurrentQueue };
    });
  }

  private mapQueueDetails(queueIds: any[]): any[] {
    return queueIds
      .map(id => this.queues.find(q => q.id === id))
      .filter(Boolean);
  }


  closePopup(ucid: string) {
    this.callService.removeCall(ucid);
  }


  setResultCodes() {
    this.resultCodes = this.resultCodes.map(res => {
      res.other = !res.queues.some((item: any) => item.name === this.selectCall?.queueNumber) || false;
      return res;
    });
  }


  toggleRelatedMenu() {
    this.isMinimized = !this.isMinimized;
  }

  toggleRelatedMenuResult() {
    this.isMinimizedResult = !this.isMinimizedResult;
  }

  setOtherResult(isOtherResult: boolean) {
    this.isOtherResult = isOtherResult;
    setTimeout(function () {
      $(".result").animate({scrollTop: 500}, 500);
    }, 500);
  }

  openDialog(item: any) {
    this.selectRelatedTab = '';
    this.call = item;
    this.visible = true;
    if (this.call?.card?.patient) {
      this.selectRelatedTab = 'patient';
    } else if (this.call?.card?.instituation) {
      this.selectRelatedTab = 'instituation';
    } else if (this.call?.card?.caseOngoingPatientInformation || (this.call?.card?.case && this.call?.card?.case?.status == 'started')) {
      this.selectRelatedTab = 'caseOngoingPatientInformation';
      if (this.call?.card?.case) {
        this.call.card.caseOngoingPatientInformation = {...this.call?.card?.case, ...this.call?.card?.case.patientInformations.patient};
        this.call.card.caseOngoingPatientInformation.cases = {...this.call?.card?.case, ...this.call?.card?.case.patientInformations.patient};
        this.call.card.caseEndedPatientInformation.patient = this.call?.card?.case.patientInformations.patient;

      }
    } else if (this.call?.card?.caseEndedPatientInformation || (this.call?.card?.case && this.call?.card?.case?.status == 'finished')) {
      this.selectRelatedTab = 'caseEndedPatientInformation';
      if (this.call?.card?.case) {
        this.call.card.caseEndedPatientInformation = {...this.call?.card?.case, ...this.call?.card?.case.patientInformations.patient};
        this.call.card.caseEndedPatientInformation.cases = {...this.call?.card?.case, ...this.call?.card?.case.patientInformations.patient};
        this.call.card.caseEndedPatientInformation.patient = this.call?.card?.case.patientInformations.patient;
      }

    }
  }

  cancelDialog() {
    this.visible = false;
  }

  showPatient(patient?: any) {
    this.showPatientForm.initialize(
      patient
    )
  }

  setRelated(data: any, relatedType: string) {
    if (data) {
      this.selectedRelated = data;
      let postData = {};
      switch (relatedType) {
        case 'patients':
          postData = {patientId: data.id};
          break;
        case 'instituations':
          postData = {instituationId: data.id};
          break;
        default:
          break;
      }
      this.apiService.post('cards/set-call-card-related', {...postData, id: this.selectCall.card.id }).subscribe((res) => {
        this.messageService.successToast(this.translateService.instant('common.success'), this.translateService.instant('common.saveSuccessToastMessage'));
        this.calls[this.calls.indexOf(this.selectCall)].card = res;
      });
    }
  }

  setCardResultCodeConfirmMessage(status: any) {
    this.appAlertService.sweetConfirm({
      header: this.translateService.instant('general.is-status-save'),
      message: this.translateService.instant(status.name),
      showCloseButton: true, 
      accept: () => this.setCardResultCode(status),
    });
  }

  setCardResultCode(status: any) {
    if (status) {
      this.apiService.post('cards/set-call-card-result-code', {
        id: this.selectCall.card.id,
        resultCode: status.id
      }).subscribe((res) => {
        this.messageService.successToast(this.translateService.instant('common.success'), this.translateService.instant('common.saveSuccessToastMessage'));
        this.calls.splice(this.calls.indexOf(this.selectCall), 1);
        this.closePopup(this.selectCall.ucid || '');
        const key = status.key.split("-");
        if (key[0] === 'screen') {
          this.router.navigate([key[1]], { queryParams: { openSidebar: true } });
        }
      });
    }
  }

  protected readonly split = split;
}
